import React from 'react'
import PropTypes from 'prop-types'

class ColorPicker extends React.Component {
  constructor(props) {
    super(props)

    this.changeColor = this.changeColor.bind(this)
  }

  componentDidMount() {
    const { value } = this.props

    this.colorpicker = $(this.refs.colorPicker)
    this.colorpicker.spectrum({
      preferredFormat: 'hex',
      showInput: true,
      showPalette: true,
      showSelectionPalette: true,
      palette: [],
      color: value || '#000000',
      showButtons: false,
      move: (color) => {
        this.changeColor(color)
      },
    })
  }

  componentWillReceiveProps(newProps) {
    const { value } = newProps

    if (value) {
      this.colorpicker.spectrum('set', value)
    }
  }

  componentWillUnmount() {
    this.colorpicker.spectrum('destroy')
    this.colorpicker = undefined
  }

  changeColor(color) {
    const { canvas } = this.props
    const textElement = canvas.getActiveObject()

    if (!textElement) {
      this.colorpicker.spectrum('hide')
      return
    }

    textElement.setColor(color.toHexString())
    canvas.renderAll()
  }

  render() {
    const { visible } = this.props

    if (!visible && this.colorpicker) {
      this.colorpicker.spectrum('hide')
    }

    return (
      <div className={`letterHeaderTools_color ${!visible ? 'u_hidden' : ''}`}>
        <input ref='colorPicker' />
      </div>
    )
  }
}

ColorPicker.propTypes = {
  canvas: PropTypes.object,
  visible: PropTypes.bool,
}

export default ColorPicker
